import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Tabs,
  Tab,
  IconButton,
   Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import CreateCategoryGroupForm from "../components/PagesComponents/MenuManagement/Category/AddCategory";
import AddProductsForm from "../components/PagesComponents/MenuManagement/products/AddProductsForm";
import CategoryGroupTabs from "../components/PagesComponents/MenuManagement/Category/getCategory";
import ProductTabs from "../components/PagesComponents/MenuManagement/products/ProductTabs";
import CreateOfferForm from "../components/PagesComponents/MenuManagement/Offers/CreateOfferForm";
import OfferList from "../components/PagesComponents/MenuManagement/Offers/OfferList"; // ✅ مكون عرض العروض
import { getAllCategoryGroups } from "../services/menuPage";
import { useFeatures } from "../context/PermissionsAndFeatures/FeaturesContext";


const MenuManagement = () => {
  const [openGroupDialog, setOpenGroupDialog] = useState(false);
  const [openProductDialog, setOpenProductDialog] = useState(false);
  const [openOfferDialog, setOpenOfferDialog] = useState(false);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = localStorage.getItem("menu_active_tab");
    return savedTab ? Number(savedTab) : 0;
  });
  const [refreshOffers, setRefreshOffers] = useState(0); // ✅ لتحديث قائمة العروض

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { hasFeature } = useFeatures();
const [message, setMessage] = useState(null);

// هل الميزة مفعّلة؟
const isFeatureEnabled =
  typeof hasFeature === "function"
    ? hasFeature("offers")
    : hasFeature?.offers !== undefined
    ? !!hasFeature.offers
    : true;


  const fetchGroups = async () => {
    setLoading(true);
    try {
      const data = await getAllCategoryGroups();
      setGroups(data);
      setError(null);
    } catch (err) {
      console.error("فشل في جلب المجموعات:", err.message);
      setError("فشل في تحميل المجموعات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const handleAddGroupSuccess = () => {
    fetchGroups();
    setOpenGroupDialog(false);
  };

  const handleAddProductSuccess = () => {
    fetchGroups();
    setOpenProductDialog(false);
  };

  const handleAddOfferSuccess = () => {
    setOpenOfferDialog(false);
    setRefreshOffers((prev) => prev + 1); // ✅ يحدث القائمة عند كل إضافة
  };

  const handleTabChange = (e, newVal) => {
    setActiveTab(newVal);
    localStorage.setItem("menu_active_tab", newVal);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>إدارة القائمة</Typography>

      <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="المجموعات" />
        <Tab label="الأصناف" />
        <Tab label="العروض" />
      </Tabs>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        {activeTab === 0 && (
          <Button variant="contained" color="secondary" onClick={() => setOpenGroupDialog(true)}>
            إضافة مجموعة أصناف
          </Button>
        )}
        {activeTab === 1 && (
          <Button variant="contained" color="primary" onClick={() => setOpenProductDialog(true)}>
            إضافة منتج جديد
          </Button>
        )}
       {activeTab === 2 && (
  <>
    <Button
      variant="contained"
      color="success"
      onClick={() => {
        if (!isFeatureEnabled) {
          setMessage("🚫 هذه الميزة غير مفعّلة حاليًا. يرجى التواصل مع الإدارة لتفعيل ميزة العروض.");
          return;
        }
        setOpenOfferDialog(true);
      }}
    >
      إنشاء عرض جديد
    </Button>

    {message && (
      <Alert
        severity="warning"
        sx={{ mt: 2 }}
        onClose={() => setMessage(null)}
      >
        {message}
      </Alert>
    )}
  </>
)}

      </Stack>

      {activeTab === 0 && (
        <CategoryGroupTabs
          groups={groups}
          loading={loading}
          error={error}
          onUpdate={fetchGroups}
        />
      )}

      {activeTab === 1 && <ProductTabs />}
      {activeTab === 2 && <OfferList refresh={refreshOffers} />} {/* ✅ تمرير التحديث */}

      {/* Dialogs */}
      <Dialog
        open={openGroupDialog}
        onClose={() => setOpenGroupDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>إضافة مجموعة أصناف جديدة</DialogTitle>
        <DialogContent>
          <CreateCategoryGroupForm onSuccess={handleAddGroupSuccess} />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProductDialog}
        // لا نغلق المودال عند النقر على الخلفية أو الضغط على Escape
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenProductDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 1 }}>
          <Box component="span" sx={{ fontWeight: 700, fontSize: 18 }}>إضافة منتج جديد</Box>
          <IconButton
            aria-label="إغلاق المودال"
            onClick={() => setOpenProductDialog(false)}
            size="small"
            sx={{
              bgcolor: "rgba(0,0,0,0.04)",
              color: "inherit",
              "&:hover": { bgcolor: "rgba(0,0,0,0.08)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <AddProductsForm onSuccess={handleAddProductSuccess} />
        </DialogContent>
      </Dialog>

      <Dialog
        open={openOfferDialog}
        // منع الإغلاق بواسطة backdrop أو ESC — يسمح فقط بالإغلاق عن طريق أيقونة الإغلاق أو عند نجاح الحفظ
        onClose={(e, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenOfferDialog(false);
        }}
        disableEscapeKeyDown
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            width: "90vw",
            maxWidth: "1200px",
            height: "85vh",
            maxHeight: "95vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle sx={{ position: "relative", pr: 6 }}>
          إنشاء عرض جديد
          <IconButton
            aria-label="close"
            onClick={() => setOpenOfferDialog(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <CreateOfferForm onSuccess={handleAddOfferSuccess} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default MenuManagement;
